<template>
  <!-- 创建团队 -->
  <el-card shadow="never" class="create_card">
    <div slot="header" class="clearfix">
      <div class="desciconLarge" v-if="info.title == '创建团队'"></div>
      <el-button type="text" class="backBtn" v-if="info.title == '编辑团队信息'" @click="changeBack">返回</el-button>
      <span class="font18">{{info.title}}</span>
    </div>
    <el-form ref="form" :model="form" :rules="rules" :disabled="editPending" label-width="120px" label-position="left" style="width: 70%">
      <el-form-item label="团队名称" prop="teamName">
        <el-input v-model="form.teamName" placeholder="请输入团队名称"></el-input>
      </el-form-item>
      <el-form-item label="团队头像">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl"
          :show-file-list="false"
          :headers="headers"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <el-image :src="imageUrl" class="avatar" v-if="imageUrl">
              <div slot="error">
                  <img src="@/assets/img/avatarTeam.png" class="avatar" />
              </div>
          </el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="所在省市" prop="regionValue">
        <el-cascader
          @change="handleChange"
          placeholder="请选择所在省市"
          style="width: 100%"
          :options="regionData"
          v-model="form.regionValue"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址" prop="address">
        <el-input v-model="form.address" placeholder="请输入详细地址"></el-input>
      </el-form-item>
      <el-form-item label="团长姓名" prop="teamHeadName">
        <el-input v-model="form.teamHeadName" disabled placeholder="暂无“团长姓名”信息"></el-input>
      </el-form-item>
      <el-form-item label="团长电话" prop="teamHeadPhone">
        <el-input v-model="form.teamHeadPhone" disabled placeholder="暂无“团长电话”信息"></el-input>
      </el-form-item>
      <el-form-item label="团长邮箱" prop="teamHeadEmail">
        <el-input v-model="form.teamHeadEmail" disabled placeholder="暂无“团长邮箱”信息"></el-input>
      </el-form-item>
      <el-form-item label="免审核设置" prop="freePay" id="tagOther">
        <div style="display: flex;">
          <el-tag
            v-for="item in checkList"
            :key="item.value"
            :effect="form.paymentAudit == item.value ? 'dark' : 'light'"
            :type="form.paymentAudit == item.value ? '' : 'info'"
            @click="changePaymentAudit(item.value)"
          >{{ item.name }}</el-tag>
          <div style="display: flex; justify-content: space-between; align-items: center; width: 350px; margin-left: 50px;" v-if="form.paymentAudit == 1">
            <div>设置单笔订单免审核额度</div>
            <el-input-number v-model="form.freePay" :min="1" :max="10000" :disabled="show_checkBox"></el-input-number>
          </div>
        </div>
        <div  class="tipsWord">开启免审核设置后，在设定额度之下，团员下单无需团长/管理员审核</div>
      </el-form-item>
      <el-form-item label="预存限制" id="tagOther">
        <el-tag
          v-for="item in prestoreControlList"
          :key="item.value"
          :effect="form.prestoreSwitch == item.value ? 'dark' : 'light'"
          :type="form.prestoreSwitch == item.value ? '' : 'info'"
          @click="!editPending && (form.prestoreSwitch = item.value)"
        >{{ item.label }}</el-tag>
      </el-form-item>
      <el-form-item v-if="info.title == '编辑团队信息'" label="个人信用限制" id="tagOther">
        <el-tag
          v-for="item in prestoreControlList"
          :key="item.value"
          :effect="form.oneCreditSwitch == item.value ? 'dark' : 'light'"
          :type="form.oneCreditSwitch == item.value ? '' : 'info'"
          @click="!editPending && (form.oneCreditSwitch = item.value)"
        >{{ item.label }}</el-tag>
        <div class="tipsWord">开启限制后，所有成员(包括团长、管理员)不能使用个人信用支付</div>
      </el-form-item>
    </el-form>
    <div style="width: 70%;text-align: center">
      <el-button type="primary" style="width: 150px" @click="submit()" v-if="info.title == '创建团队'">创建团队</el-button>
      <el-button type="primary" style="width: 150px" :loading="editPending" @click="editSubmit()" v-if="info.title == '编辑团队信息'">确认编辑</el-button>
    </div>

    <el-dialog title="开通支付免审核服务" :close-on-click-modal="false" :visible.sync="show_checkBox" width="20%" :before-close="closeCheckBox">
      <div>
        <div style="display: flex; justify-content: space-between;">
          <div style="width: 250px;">服务内容</div>
          <div>“在纳微(含纳微创新小程序纳微官方网页)团队管理中团长、管理员无需审核订单，快速审批订单，便于团员检测，并可在“我的-我的团队-支付审核”中随时取消”</div>
        </div>
        <div style="display: flex; justify-content: space-between; margin-top: 20px;">
          <div style="width: 250px;">开通账号</div>
          <div> {{ form.teamName }} </div>
        </div>
        <div style="cursor: pointer; margin-top: 20px;" @click="goAgreement">
          <span>查看</span>
          <span style="color: #4D6FFF; text-decoration: underline;">《付款授权服务协议》</span>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="confirmCheckBox">同意协议并开通免审核支付</el-button>
        <el-button @click="closeCheckBox">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="订单免审核授权服务协议" :visible.sync="show_agreementBox" width="40%">
      <agreementText :team_name="form.teamName"></agreementText>
      <span slot="footer">
        <el-button type="primary" @click="show_agreementBox = false">确认</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>
<script>
import agreementText from "@/pages/aboutUs/agreementText";
import { mapGetters } from "vuex";
import { regionData, codeToText } from "element-china-area-data";
import { getToken } from "@/plugins/auth";
import { creatTeam,editTeam,teamInfo } from "@/api/request";
import { isMobile, validEmail } from "@/plugins/validate";

export default {
  components: { agreementText },
  props: {
    info: {
      type: [Object, Array],
      default: () => {}
    }
  },
  data() {
        var validateMobile = (rule, value, callback) => {
      if (value && !isMobile(value)) {
        return callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    var validemail = (rule, value, callback) => {
      if (value && !validEmail(value)) {
        return callback(new Error("请输入正确的邮箱"));
      }
      callback();
    };
    return {
      teamInfo: {},
      show_checkBox: false,
      show_agreementBox: false,
      editPending: false,
      regionData,
      typeOptions: [],
      checkList: [
        {name: '开启审核',value: 1},
        {name: '暂不审核',value: 0}
      ],
      //预存限制选择列表
      prestoreControlList: [
        {label: '开启限制', value: 1},
        {label: '关闭限制', value: 0},
      ],
      form: {
        teamId: undefined,
        teamName: "",
        teamProFilePhoto: "",
        region: "",
        regionCode: "",
        regionValue: [],
        address: "",
        teamHeadName: "",
        teamHeadPhone: "",
        teamHeadEmail: "",
        paymentAudit: 1,
        freePay: 1,
        prestoreSwitch: 0,
        oneCreditSwitch: 0,
      },
      imageUrl: "",
      uploadUrl: process.env.VUE_APP_BASE_API + "/file/upload",
      headers: {
        Authorization: "Bearer " + getToken()
      },
      fileType: "JPG,JPEG,PNG",
      rules: {
        teamName: [
          { required: true, trigger: "blur", message: "请输入团队名称" },
          { max: 30, message: "团队名称不能超过30个字", trigger: "blur" }
        ],
        regionValue: [
          { required: true, trigger: "change", message: "请选择所在省市" }
        ],
        teamHeadName: [
          { required: true, trigger: "blur", message: "请输入团长姓名" },
          { max: 30, message: "团队姓名不能超过30个字", trigger: "blur" }
        ],
        address: [
          { max: 100, message: "地址不能超过100个字", trigger: "blur" }
        ],
        teamHeadPhone: [
          { required: true, trigger: "blur", message: "请输入团长电话" },
          { validator: validateMobile, trigger: "blur" }
        ],
        freePay: [
          { validator: (rule, value, callback) => {
            if(this.form.paymentAudit == 1 && (value == null || value < 1 || value > 10000)) {
              return callback(new Error("请输入1至10000之间的单笔订单免审核额度"))
            }
            callback()
          }, trigger: "change" }
        ],
      }
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.form.teamHeadName = this.userInfo.clientName
    this.form.teamHeadPhone = this.userInfo.phoneNumber
    this.form.teamHeadEmail = this.userInfo.email
  },
  async mounted() {
    if(this.info.title == '编辑团队信息') {
      const res = await teamInfo(this.userInfo.teamId)
      this.teamInfo = res.data
      const { teamId, teamName, teamProFilePhoto, region, regionCode, address, paymentAudit, freePay, prestoreSwitch, oneCreditSwitch } = res.data
      const obj = { teamId, teamName, teamProFilePhoto, region, regionCode, address, paymentAudit: Number(paymentAudit), freePay, prestoreSwitch: Number(prestoreSwitch), oneCreditSwitch: Number(oneCreditSwitch) === 1 ? 1 : 0 }
      for(let key in obj) {
        this.form[key] = obj[key]
      }
      this.form.regionValue = res.data.regionCode.split(",")
      this.imageUrl = this.teamInfo.teamProFilePhoto ? process.env.VUE_APP_FILE_API + this.teamInfo.teamProFilePhoto : "@/assets/img/avatarTeam.png";
    }
  },
  methods: {
    handleChange(value) {
      this.form.regionValue = value;
      this.form.regionCode = value.toString();
      this.form.region = this.getCodeToText(value);
    },
    //把区域码转成汉字
    getCodeToText(value) {
      var name = "";
      value.map(item => (name += codeToText[item] + "/"));
      return name;
    },
    handleAvatarSuccess(res, file) {
      this.form.teamProFilePhoto = res.data.url;
      this.imageUrl = process.env.VUE_APP_FILE_API + res.data.url;
    },
    changePaymentAudit (value) {
      if(this.editPending || this.show_checkBox || this.form.paymentAudit == value) return
      this.form.paymentAudit = value
      this.$refs.form.clearValidate('freePay')
      if(value == 1) {
        this.show_checkBox = true
      }
    },
    // 免审核开关、额度、预存及个人信用限制随团队信息保存；失败时保留表单设置以便重试。
    confirmCheckBox() {
      this.form.paymentAudit = 1
      this.show_checkBox = false
    },
    closeCheckBox() {
      this.show_checkBox = false
      this.form.paymentAudit = 0
    },

    beforeAvatarUpload(file) {
      if (
        file.type != "image/jpeg" &&
        file.type != "image/png" &&
        file.type != "image/jpg"
      ) {
        return this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      return true;
    },
    changeBack () {
      this.$emit('back')
    },
    submit () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const data = { ...this.form }
          delete data.oneCreditSwitch
          await creatTeam(data).then(res => {
            this.$message.success("创建成功");
            this.$store.dispatch("GetInfo").then(() => {}).catch(err => {});
            this.$nextTick(()=> {
              this.$emit('selectSubName',{index: '4-3',title: '我的团队'})
            })
          });
        }
      });
    },
    editSubmit () {
      if(this.editPending || this.show_checkBox) return
      this.$refs.form.validate(async valid => {
        if (valid && !this.editPending) {
          this.editPending = true
          try {
            // 基础信息与支付设置统一提交，不再单独调用各开关接口。
            const res = await editTeam({ ...this.form })
            if(res.code !== 200) {
              this.$message.error(res.msg || "编辑失败")
              return
            }
            this.$message.success("编辑成功");
            this.$store.dispatch("GetInfo").then(() => {}).catch(err => {});
            this.changeBack()
          } catch (error) {
            // 接口异常由请求拦截器提示，保留已填写内容以便重新提交。
          } finally {
            this.editPending = false
          }
        }
      });
    },
    //前往付款授权服务协议
    goAgreement() {
      this.show_agreementBox = true
    },
  }
};
</script>
<style scoped>
.avatar-uploader {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
